import { render, staticRenderFns } from "./PreScreening.vue?vue&type=template&id=2309da9c&scoped=true"
import script from "./PreScreening.vue?vue&type=script&lang=js"
export * from "./PreScreening.vue?vue&type=script&lang=js"
import style0 from "./PreScreening.vue?vue&type=style&index=0&id=2309da9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2309da9c",
  null
  
)

export default component.exports